import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBarProps {
  routes: string[];
}

const SearchBar: React.FC<SearchBarProps> = ({ routes }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState<string[]>([]);
  const navigate = useNavigate();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    setSearchTerm(query);

    if (query.trim()) {
      setFilteredSuggestions(
        routes.filter(route => route.toLowerCase().includes(query.toLowerCase()))
      );
    } else {
      setFilteredSuggestions([]);
    }
  };

  const handleSuggestionClick = (suggestion: string) => {
    setSearchTerm(suggestion);
    setFilteredSuggestions([]);
    navigate(`/${suggestion}`); // Navigate to the corresponding page
  };

  return (
    <div style={{ position: "relative" }}>
      <input
        type="text"
        value={searchTerm}
        onChange={handleSearchChange}
        placeholder="Search..."
        className="form-control"
        style={{ width: "200px" }}
      />
      {filteredSuggestions.length > 0 && (
        <ul
          className="suggestions-list"
          style={{
            position: "absolute",
            backgroundColor: "#fff",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            width: "200px",
            zIndex: 9999999,
            padding: 0,
            margin: 0,
            top: "100%",
            left: 0,
            display: filteredSuggestions.length ? "block" : "none",
          }}
        >
          {filteredSuggestions.map((suggestion, index) => (
            <li
              key={index}
              onClick={() => handleSuggestionClick(suggestion)}
              style={{
                cursor: "pointer",
                padding: "8px",
                listStyleType: "none",
                position: "relative",
              }}
            >

              {suggestion}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchBar;